/**
 * Scales images to be visually proportionate based on aspect ratio. An implementation of https://danpaquette.net/read/automatically-resizing-a-list-of-icons-or-logos-so-theyre-visually-proportional/
 * @param {string} selector - An element selector for a set of elements to normalise
 * @param {int} widthBase - The width a square image would be scaled to
 * @param {int} scaleFactor - A balancing factor between scaling for height and width. The default is generally visually balanced.
 * @param {Element} parentEl - A parent element to search for the selector. Defaults to document.
 * Example usage, scaling home banner images to an average of 40px width:
 * window.onload = function() { 
 *     proportionalImageNormalisation(".banners-home .banner-inner-image", 40);
 * };
 */ 

function adjustImageWidth(element, widthBase, scaleFactor = 0.525) {
	let imageRatio;
	if (element instanceof HTMLImageElement) {
		imageRatio = element.naturalWidth / element.naturalHeight;
		element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + "px";
	} else if (element instanceof HTMLPictureElement) {
		let imageElement = element.querySelector("img");
		imageRatio = imageElement.naturalWidth / imageElement.naturalHeight;
		element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + "px";
	} else {
		imageRatio = element.clientWidth / element.clientHeight;
		element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + "px";
	}
}

export function ProportionalImageNormalisation(selector, widthBase = 50, scaleFactor = 0.525, parentEl = document) {
	const elements = Array.from(parentEl.querySelectorAll(selector));

	// Initial adjustment for each image
	elements.forEach((element) => {
		const imageElement = element instanceof HTMLPictureElement
			? element.querySelector("img")
			: element;

		const callback = () => adjustImageWidth(element, widthBase, scaleFactor);
		checkIfLazyLoad(imageElement, callback);
	});

	// Debounced resize handler
	const resizeHandler = debounce(() => {
		elements.forEach(el => adjustImageWidth(el, widthBase, scaleFactor));
	}, 150);

	window.addEventListener("resize", resizeHandler);
}

export function checkIfLazyLoad(img_element, callback) {
	if (img_element.loading === "lazy") {
		if (img_element.complete) {
			callback();
		} else {
			img_element.addEventListener("load", callback);
		}
	} else {
		// Handle non-lazy images too if needed
		if (img_element.complete) {
			callback();
		} else {
			img_element.addEventListener("load", callback);
		}
	}
}

function debounce(fn, delay = 100) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), delay);
	};
}